import { ApplicationConfig, isDevMode } from '@angular/core';
import { provideAuthInitializer } from '@pool-league/frontend-shared-util-auth';
import { provideApiConfig } from '@pool-league/frontend-shared-util-app-config';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { provideKillerWebSocketConfig } from '@pool-league/frontend-shared-data-killer';
import { KILLER_WS_URL } from '@pool-league/frontend-shared-data-killer/test-config';

export const environment: ApplicationConfig = {
  providers: [
    provideAuthInitializer({
      issuer: 'https://cognito-idp.eu-west-2.amazonaws.com/eu-west-2_7G6vete7z',
      clientId: 'eireurfipm5ce1lcpl95e814c',
    }),
    provideApiConfig('https://kr5ajqnj8g.execute-api.eu-west-2.amazonaws.com'),
    provideKillerWebSocketConfig({
      endpoint: KILLER_WS_URL,
    }),
    provideStoreDevtools({
      maxAge: 25,
      logOnly: !isDevMode(),
      autoPause: true,
      trace: isDevMode(),
      traceLimit: 75,
    }),
  ],
};
